<template>
	<div class="content-class">
		<v-tabs color="black" dark slider-color="primary">
			<v-tab ripple>Ajouter un bot</v-tab>
		</v-tabs>
		<bot-form v-model="document"> </bot-form>
	</div>
</template>

<script>
import BotForm from '../../components/bots/bot.form'

export default {
	components: { BotForm },
	data() {
		return {
			document: {
				schedulers: [],
				themes: [],
				variables: [],
				isAsko: true,
				saveNavigationTime: true,
				schedulerActivated: true,
				subBots: [],
				apiKey: crypto.randomUUID().replace(/-/g, ''),
			},
		}
	},
	methods: {
		duplicate: async function(botId) {
			try {
				const bot = (await this.axios.get(`bots/${botId}`)).data
				const subBots = (await this.axios.get(`subBots?filter=bot._id:$eq:${botId}`)).data.resources
				console.log('dulicuates!!!', subBots, bot)

				// TODO les datas se mettent mal (vairiable schedulers et subbots)
				// //=> tout bien véririfier !

				this.document.isAsko = bot.isAsko
				this.document.saveNavigationTime = bot.saveNavigationTime
				this.document.licensed = bot.licensed
				this.document.newUserSibId = bot.newUserSibId
				this.document.reminderSibId = bot.reminderSibId
				this.document.reminderScheduleSibId = bot.reminderScheduleSibId
				this.document.variables = bot.variables.map((variable) => ({
					...variable,
					_id: undefined,
				}))
				this.document.themes = bot.themes
				this.document.schedulerActivated = bot.schedulerActivated

				this.document.subBots = subBots.map((subBot) => ({
					name: subBot.name,
					ref: '',
					key: subBot.key,
					message: subBot.message,
				}))

				// convert _id <=> name
				this.document.schedulers = bot.schedulers.map((scheduler) => ({
					...scheduler,
					subBots: scheduler.subBots.map((subBot) => {
						const foundSubBot = subBots.find((sb) => sb._id === subBot._id)

						return {
							...subBot,
							ref: '',
							_id: foundSubBot ? foundSubBot.name : undefined,
						}
					}),
				}))

				console.log('document', this.document)
			} catch (err) {
				console.log(err)
			}
		},
	},
	mounted() {
		if (this.$route.query.duplicate) {
			this.duplicate(this.$route.query.duplicate)
		}
	},
}
</script>

<style lang="scss">
.content-class {
	width: 100%;
	height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/bots/bot.add.vue